import React from 'react';
import {
  useMixpanelTrack,
} from 'core/hooks';
import {
  appointmentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  appointmentOptions,
} from 'pages/Dashboard/pages/Appointments/pages/List/components/CreateAppointmentDialog';
import {
  DropdownMenuItem,
} from 'core/components/DropdownMenu';
import SplitActionButton from 'core/components/SplitActionButton';
import AddIcon from '@mui/icons-material/Add';

const iconClassName = '!w-4 !h-4 !text-blue-500';

export default function EventCreateButton() {
  const mixpanelTrack = useMixpanelTrack();

  const onEventCreate = (eventType: number = 0) => {
    appointmentsEventChannel.emit('onEventCreate', {
      defaultEventType: eventType,
    });
    mixpanelTrack('createAppointment', { source: 'button' });
  };

  const menuItems: DropdownMenuItem[] = appointmentOptions.map(({ key, label, Icon }, index) => ({
    id: key,
    label,
    icon: Icon,
    iconClassName,
    onSelect: () => { onEventCreate(index); },
  }));

  return (
    <SplitActionButton
      label="Create"
      onPrimaryClick={() => { onEventCreate(0); }}
      items={menuItems}
      startIcon={<AddIcon className="!w-4 !h-4" />}
      classes={{ primary: 'nw-create-appointment' }}
      paperClassName="!min-w-[8rem] nw-create-options"
      placement="bottom-end"
    />
  );
}
